module.exports = __webpack_public_path__ + "img/bittner-pharma-1.f7d022e.jpg";